import { Component } from '@angular/core';

@Component({
  selector: 'app-cindi',
  imports: [],
  templateUrl: './cindi.html',
  styleUrl: './cindi.scss'
})
export class Cindi {

}
